"use strict";
export const PaymentCoinsMock = (mock) => {
  mock.onPost("/api/v7/payment/discount_coupon_options/create").reply((config) => {
    let response = {
      "total": 1,
      "datas": [
        {
          "goods_specs": [
            {
              "model": "good_spec.guid.model",
              "name": "1\u4E2A\u6708",
              "guid": "goods_spec_58d69c54afd84f04a407fed8d248d00c"
            }
          ],
          "can_not_use_reason": null,
          "regions": [
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u4E0A\u6D77-\u963F\u91CC",
              "guid": "ip_region_1f8abc0477d24dc4a87828706760e3bf"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u547C\u548C\u6D69\u7279-\u963F\u91CC",
              "guid": "ip_region_35dd786c8648406e9c5fda9e85ee6076"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u9752\u5C9B-\u963F\u91CC",
              "guid": "ip_region_3bcede8fa391412498094a2e04c27d75"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u676D\u5DDE-\u963F\u91CC",
              "guid": "ip_region_53bb40b895344c368b63a0106ff25511"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u6DF1\u5733-\u963F\u91CC",
              "guid": "ip_region_8a0dd3e12c164add99fae523b4e12f2a"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u5E7F\u4E1C-\u6CB3\u6E90-\u963F\u91CC",
              "guid": "ip_region_cf5882b4ac18448bb4e067d20c29fb81"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u6210\u90FD-\u963F\u91CC",
              "guid": "ip_region_dd094e8c0c4f4a898f327d51b34ce05a"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u5F20\u5BB6\u53E3-\u963F\u91CC",
              "guid": "ip_region_f1d57fbda6de4119a7956e5d858e532c"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E2D\u56FD\u5927\u9646-\u5317\u4EAC-\u963F\u91CC",
              "guid": "ip_region_f3f5f3a6acc44835aef349d586d5435c"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u6B27\u6D32-\u5FB7\u56FD-\u6CD5\u5170\u514B\u798F-\u963F\u91CC",
              "guid": "ip_region_30971f9f091b4666a963aa46ce8603ee"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u6B27\u6D32-\u82F1\u56FD-\u4F26\u6566-\u963F\u91CC",
              "guid": "ip_region_935da4c0ba6142c29bfecb7211b13c87"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E9A\u6D32-\u5370\u5C3C-\u96C5\u52A0\u8FBE-\u963F\u91CC",
              "guid": "ip_region_4d0c052170e24976a89137b32c9dff89"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E9A\u6D32-\u4E2D\u4E1C-\u8FEA\u62DC-\u963F\u91CC",
              "guid": "ip_region_4e45c31652024ecf8584efafdf47676d"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E9A\u6D32-\u9A6C\u6765\u897F\u4E9A-\u5409\u9686\u5761-\u963F\u91CC",
              "guid": "ip_region_6ada31b5a1d24a628d6149ed568bd911"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E9A\u6D32-\u5370\u5EA6-\u5B5F\u4E70-\u963F\u91CC",
              "guid": "ip_region_81a45c800dbc4893bcef8a2e37944bda"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E9A\u6D32-\u65E5\u672C-\u4E1C\u4EAC-\u963F\u91CC",
              "guid": "ip_region_922d66bd0fd943ddace8ecd518913eb3"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u4E9A\u6D32-\u65B0\u52A0\u5761-\u963F\u91CC",
              "guid": "ip_region_e022c9d9f84b4dfea54f3c0462e3665b"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u5927\u6D0B\u6D32-\u6FB3\u5927\u5229\u4E9A-\u6089\u5C3C-\u963F\u91CC",
              "guid": "ip_region_c6570f1f46fb423295223d4be0942bb7"
            },
            {
              "model": "good_region.guid.model",
              "name": "\u6E2F\u6FB3\u53F0-\u9999\u6E2F-\u963F\u91CC",
              "guid": "ip_region_62dd885bdbbd42feae69a2574b5eb600"
            }
          ],
          "is_using": false,
          "coupon_data": {
            "model": "discount_coupon.fixed",
            "type": "fixed",
            "fixed_money": 19
          },
          "use_limit_desc": "\u65E0\u95E8\u69DB",
          "type": "discount_coupon",
          "valid_date": {
            "model": "coupon.valid.date",
            "start": 1621224663e3,
            "end": 1621829463e3
          },
          "can_use": true,
          "name": "19\u5143\u65B0\u7528\u6237\u4F18\u60E0\u5238",
          "scenes": [
            {
              "model": "coupon_scenes.model",
              "code": "buy_new",
              "name": "\u65B0\u8D2D"
            }
          ],
          "guid": "discount_coupon_a44627d627164b939f485dc318df4d6d",
          "style": "type1",
          "model": "payment.virtualdesktop.discount_coupon_options.creatediscount_coupon"
        }
      ],
      "type": "data.set"
    };
    return [200, response];
  });
};
